export default __webpack_public_path__ + "static/media/menu1.2286d1b3.png";